<script setup lang="ts">
  import { computed, type HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  import type { TargetPromptAiModel } from '../model/types'
  import { IconTimer } from '@gat-ship/icons'

  const props = defineProps<{
    class?: HTMLAttributes['class']
    aiModel: TargetPromptAiModel
  }>()

  const percentage = computed(() => {
    if (props.aiModel === 'light') return 25
    if (props.aiModel === 'standard') return 50
    if (props.aiModel === 'extended') return 75
    return 0
  })
</script>

<template>
  <IconTimer :percentage="percentage" :class="cn('size-4', props.class)" />
</template>
